"use client";

import { Portal as PortalBase } from "@radix-ui/react-portal";
import { type ComponentProps } from "react";
import { useIsSSR } from "react-aria";

export function Portal(props: ComponentProps<typeof PortalBase>) {
  const isClient = !useIsSSR();

  if (!isClient) {
    return null;
  }
  return <PortalBase {...props} />;
}
